import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useServicesStyles } from './ServicesSection.styles';
import { fadeUp, stagger, viewportOnce } from '../../../../styles/animations';

const services = [
    {
        title: 'Digital Strategy',
        description: 'Digital products and transformation strategies aligned with your business goals.',
    },
    {
        title: 'Software Engineering',
        description: 'Scalable digital solutions built for long-term growth.',
    },
    {
        title: 'Cloud & Infrastructure',
        description: 'Modern cloud architectures designed for performance and reliability.',
    },
];

const ServicesSection = () => {
    const { classes } = useServicesStyles();

    return (
        <Box component="section" id="services" className={classes.section}>
            <Box className={classes.inner}>
                <Box>
                    <Typography variant="overline" className={classes.eyebrow}>What we do</Typography>
                    <Typography variant="h2">Services</Typography>
                </Box>

                <motion.div
                    className={classes.list}
                    initial="hidden"
                    whileInView="visible"
                    viewport={viewportOnce}
                    variants={stagger(0.1)}
                >
                    {services.map((s, i) => (
                        <motion.div key={s.title} variants={fadeUp} className={classes.row}>
                            <Box className={classes.rowTitle}>
                                <Typography variant="overline" className={classes.index}>
                                    {String(i + 1).padStart(2, '0')}
                                </Typography>
                                <Typography variant="h4">{s.title}</Typography>
                            </Box>
                            <Typography variant="body2" className={classes.rowDescription}>
                                {s.description}
                            </Typography>
                        </motion.div>
                    ))}
                </motion.div>
            </Box>
        </Box>
    );
};

export default ServicesSection;
